// assets/js/app.js

// ========== jQuery EN PREMIER ==========
import $ from 'jquery';

// Exposer globalement AVANT tout autre import
window.$ = window.jQuery = $;
if (typeof global !== 'undefined') {
    global.$ = global.jQuery = $;
}

// ===========================================
// PATCH DE PROTECTION CONTRE LES ERREURS DOM
// ===========================================
// Ces patches empêchent les erreurs "ownerDocument is undefined"
// quand les plugins appellent des méthodes sur des éléments inexistants

(function($) {
    // Sauvegarder les méthodes originales
    const originalMethods = {
        css: $.fn.css,
        offset: $.fn.offset,
        position: $.fn.position,
        width: $.fn.width,
        height: $.fn.height,
        outerWidth: $.fn.outerWidth,
        outerHeight: $.fn.outerHeight,
        innerWidth: $.fn.innerWidth,
        innerHeight: $.fn.innerHeight
    };

    // Wrapper sécurisé pour les méthodes qui peuvent planter
    function safeMethod(methodName, defaultReturn) {
        return function(...args) {
            // Collection vide
            if (this.length === 0) {
                // Si c'est un getter (pas d'arguments ou premier arg est une string)
                if (args.length === 0 || (args.length === 1 && typeof args[0] === 'string')) {
                    return defaultReturn;
                }
                return this; // Setter: retourner this pour chaînage
            }

            // Élément détaché du DOM
            if (this[0] && !this[0].ownerDocument) {
                if (args.length === 0 || (args.length === 1 && typeof args[0] === 'string')) {
                    return defaultReturn;
                }
                return this;
            }

            // Élément valide: appeler la méthode originale
            return originalMethods[methodName].apply(this, args);
        };
    }

    // Appliquer les wrappers
    $.fn.css = safeMethod('css', '');
    $.fn.width = safeMethod('width', 0);
    $.fn.height = safeMethod('height', 0);
    $.fn.outerWidth = safeMethod('outerWidth', 0);
    $.fn.outerHeight = safeMethod('outerHeight', 0);
    $.fn.innerWidth = safeMethod('innerWidth', 0);
    $.fn.innerHeight = safeMethod('innerHeight', 0);

    // offset et position retournent des objets
    $.fn.offset = function(...args) {
        if (this.length === 0 || (this[0] && !this[0].ownerDocument)) {
            if (args.length === 0) {
                return { top: 0, left: 0 };
            }
            return this;
        }
        return originalMethods.offset.apply(this, args);
    };

    $.fn.position = function() {
        if (this.length === 0 || (this[0] && !this[0].ownerDocument)) {
            return { top: 0, left: 0 };
        }
        return originalMethods.position.apply(this);
    };

})(jQuery);

window.jQueryLoaded = true;
window.jQueryVersion = $.fn.jquery;

// ===========================================
// IMPORTS DES DÉPENDANCES
// ===========================================

// ========== Bootstrap 3 ==========
import 'bootstrap/dist/js/bootstrap.js';

// ========== Plugins npm ==========
import 'jquery-match-height';
import 'jquery-validation';
import 'waypoints/lib/jquery.waypoints.js';
import 'jquery.counterup';
import 'jquery-ui-dist/jquery-ui.js';

// ========== WOW.js ==========
import { WOW } from 'wowjs';
window.WOW = WOW;

// ========== Plugins vendors ==========
// Ces plugins peuvent s'auto-initialiser, mais les patches les protègent

import '../../public/vendors/stellar/jquery.stellar.min.js';
import '../../public/vendors/jQuery-touch-punch/jquery.ui.touch-punch.min.js';
import '../../public/vendors/fancybox/jquery.fancybox.js';
import '../../public/vendors/owl-carousel/owl.carousel.min.js';
import '../../public/vendors/jcf/js/jcf.js';
import '../../public/vendors/jcf/js/jcf.select.js';

// ========== SweetAlert2 ==========
import Swal from 'sweetalert2';
window.Swal = Swal;

// ========== Scripts custom ==========
import '../../public/js/mailchimp.js';
import '../../public/js_plugin/stickyjs/jquery.sticky.js';
import '../../public/vendors/bootstrap-datetimepicker-master/dist/js/bootstrap-datepicker.js';

// ========== jquery.main.js EN DERNIER ==========
import '../../public/js/jquery.main.js';

// ========== base.js ==========
import '../../public/js_site/base.js';

